import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { IHomePageCaseStudy } from '../interfaces/IHomePageCaseStudy';

const HOME_PAGE_CASE_STUDIES: IHomePageCaseStudy[] = [
  {
    id: 1,
    description:
      'The 3D model is way more effective at visualizing what the homeowner’s house will really look like in the future. It gives homeowners the confidence.',
    name: 'Caleb Mitchell',
    role: 'BELDON—San antonio, TX',
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        objectFit="contain"
        alt="case study"
        src="../assets/images/home_page_case_study_1.png"
      />
    ),
  },
  {
    id: 2,
    description:
      'With HOVER, we can provide homeowners with everything they need to be in control of their remodeling project and confidently make decisions. The homeowner knows exactly what to expect from the very start.',
    name: 'Chris Falasco',
    role: 'Endeavor Exteriors—Denver, CO',
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        objectFit="contain"
        alt="case study"
        src="../assets/images/home_page_case_study_2.png"
      />
    ),
  },
  {
    id: 3,
    description:
      'There has not been one time that I felt like I had to go back and re-measure a job after HOVER. I would trust a HOVER report over any project manager—including myself.',
    name: 'Bill Kassakatis',
    role: 'Hometown Exteriors—Baltimore, MD',
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        objectFit="contain"
        alt="case study"
        src="../assets/images/home_page_case_study_3.png"
      />
    ),
  },
];

export default HOME_PAGE_CASE_STUDIES;
